import { Text } from '@rsos/base-components';
import { Label } from '../../../../AirAmbulanceForm/AirAmbulanceForm/AirAmbulanceFormStandalone.styles';
import styles from './NorfolkSouthernForm.module.css';

interface FieldLabelProps {
  children: string;
  required?: boolean;
}

function FieldLabel({ children, required = false }: FieldLabelProps) {
  return (
    <Label>
      <Text size="small" color="primaryText">
        {children}
        {required && <span className={styles.required}> *</span>}
      </Text>
    </Label>
  );
}

export default FieldLabel;
